import Cookies from 'js-cookie';
import {APP_VERSION_COOKIE_KEY} from 'constants/cookie';

export const MIN_VERSION = '6.0.1';

export const isVersionSupported = (version, minVersion = MIN_VERSION) => {
  if (!version) return false;

  const toNum = (v) => v.split('.').map(Number);
  const [a, b, c] = toNum(version);
  const [ma, mb, mc] = toNum(minVersion);

  if (a !== ma) return a > ma;
  if (b !== mb) return b > mb;
  return c >= mc;
};

export const showPreKycAddFundsCta = () => {
  const params = new URLSearchParams(window.location.search);
  const appVersion = params.get('app_version') || Cookies.get(APP_VERSION_COOKIE_KEY);

  return isVersionSupported(appVersion);
};
